import * as z from "zod";

import { referrerStatusSchema, referrerSummarySchema } from "./shared";

export const listReferrers = {
  name: "listReferrers" as const,
  input: z.object({
    /** Plain integer offset to match the rest of the admin SDK. */
    offset: z.number().int().min(0).default(0),
    limit: z.number().int().min(1).max(100).default(25),
    /**
     * Substring search across email / name / referral_code via the
     * trigram indexes added in 20260426143202_add_referrer_account_search_indexes.
     * Empty string means no filter.
     */
    searchQuery: z.string().max(200).optional(),
    /** "all" or omitted = no filter; otherwise restrict to that status. */
    statusFilter: z.union([referrerStatusSchema, z.literal("all")]).optional(),
  }),
  output: z.object({
    referrers: z.array(referrerSummarySchema),
    total: z.number().int(),
  }),
};
